<div id="sidemenu" class="fixed top-0 right-0 bottom-0 w-full h-full bg-white z-[2000] flex flex-col box-border">

    <div class="drawer-header flex items-center justify-between px-4 h-16 shrink-0">
        <div class="flex items-center gap-2 cursor-pointer" (click)="clickGoMain($event)">
            <img class="h-9 w-auto" src="assets/custom/1cal-solucionait/media/iconos/icono/logo.svg"/>
            <span class="text-white font-bold text-lg">1Cal</span>
        </div>
        <button class="w-9 h-9 inline-flex items-center justify-center rounded-full text-white bg-transparent border-none cursor-pointer transition-all duration-200 hover:bg-white/20 hover:rotate-90" (click)="clickCloseMenu($event)" aria-label="Cerrar menú">
            <lucide-icon name="x" [size]="22"></lucide-icon>
        </button>
    </div>

    <div class="px-4 pt-5 pb-2 shrink-0" *ngIf="name">
        <div class="flex items-center gap-3 px-2">
            <span class="flex items-center justify-center w-11 h-11 rounded-full bg-corporate text-white text-base font-semibold shrink-0 ring-4" style="background: linear-gradient(135deg, var(--corporate-bgcolor) 0%, var(--hovercolor) 100%); --tw-ring-color: rgba(0,122,217,0.15);">{{name ? name.charAt(0).toUpperCase() : 'U'}}</span>
            <span class="flex flex-col min-w-0">
                <span class="text-[10px] uppercase tracking-wider text-[#9aa8b5]">Sesión iniciada</span>
                <span class="text-[15px] font-medium text-corporate-3 truncate">{{name}}</span>
            </span>
        </div>
    </div>

    <nav class="flex-1 min-h-0 px-4 pt-3 flex flex-col overflow-y-auto">
        <p class="text-[10px] tracking-widest uppercase text-[#9aa8b5] px-4 mb-2">Navegación</p>
        <a href="#" (click)="goToCalendar($event)"
           class="menu-item" [class.menu-active]="activeSection==='calendar'">
            <span class="menu-icon" [class.menu-icon-active]="activeSection==='calendar'">
                <lucide-icon name="calendar" [size]="18"></lucide-icon>
            </span>
            <span class="text-[14px] truncate" [class.menu-label-active]="activeSection==='calendar'">Calendario</span>
            <span *ngIf="activeSection==='calendar'" class="menu-active-dot"></span>
        </a>

        <a href="#" (click)="goToSchedules($event)"
           class="menu-item" [class.active]="activeSection==='schedules'">
            <span class="menu-icon" [class.menu-icon-active]="activeSection==='schedules'">
                <lucide-icon name="clock" [size]="18"></lucide-icon>
            </span>
            <span class="text-[14px] truncate" [class.menu-label-active]="activeSection==='schedules'">Horarios</span>
            <span class="menu-active-dot" *ngIf="activeSection==='schedules'"></span>
        </a>

        <a href="#" (click)="goToOperators($event)"
           class="menu-item" [class.active]="activeSection==='operators'">
            <span class="menu-icon" [class.menu-icon-active]="activeSection==='operators'">
                <lucide-icon name="users" [size]="18"></lucide-icon>
            </span>
            <span class="text-[14px] truncate" [class.menu-label-active]="activeSection==='operators'">
                Operarios
            </span>
            <span class="menu-active-dot" *ngIf="activeSection==='operators'"></span>
        </a>

        <div class="menu-separator"></div>

        <a href="#" (click)="clickGoMain($event)"
           class="menu-item">
            <span class="menu-icon">
                <lucide-icon name="building-2" [size]="18"></lucide-icon>
            </span>
            <span class="text-[14px] truncate">Centros</span>
            <lucide-icon name="chevron-right" [size]="16" class="ml-auto text-[#9aa8b5] shrink-0"></lucide-icon>
        </a>

        <a href="#" (click)="clickExit($event)"
           class="menu-item menu-item-danger mt-auto">
            <span class="menu-icon menu-icon-danger">
                <lucide-icon name="log-out" [size]="18"></lucide-icon>
            </span>
            <span class="text-[14px] text-error truncate">Cerrar Sesión</span>
        </a>
    </nav>

    <div class="px-4 py-3 shrink-0 text-center">
        <span class="text-[11px] text-[#b6c2cd]">1Cal · Gestión de calendarios</span>
    </div>
</div>